import { SET_TEAM, GET_TEAM, UPDATE_TEAM, DELETE_TEAM } from "./actionType";

export const setTeam = (teamData) => {
  return {
    type: SET_TEAM,
    payload: teamData,
  };
};

export const getTeam = (teamData) => {
  return {
    type: GET_TEAM,
    payload: teamData,
  };
};
export const updateTeam = (teamData) => {
  return {
    type: UPDATE_TEAM,
    payload: teamData,
  };
};
export const deleteTeam = (teamData) => {
  return {
    type: DELETE_TEAM,
    payload: teamData,
  };
};
